import {Radio, RadioProps, useStyleConfig} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends RadioProps {}

export const UiRadio = memo(
  React.forwardRef<'input', RadioProps>(({...rest}: Props, ref: React.ForwardedRef<any>) => {
    return <Radio ref={ref} _focus={{boxShadow: 'none'}} {...rest}></Radio>;
  }),
);
